import {listen} from '@exadel/esl';
import {ESLMediaQuery, ESLMediaShortcuts} from '@exadel/esl/modules/esl-media-query/core';
import {isReducedMotion} from '@exadel/esl/modules/esl-utils/environment';
import {ESLEventUtils} from '@exadel/esl/modules/esl-utils/dom';

export class HPEReducedMotionInit {
  protected static readonly KEY = 'cinematic-control';

  static init(): void {
    ESLEventUtils.subscribe(window, this.onReducedMotionChange); // window as a host to ensure single instance
    const initial = localStorage.getItem(this.KEY) || (isReducedMotion ? 'off' : 'on');
    ESLMediaShortcuts.set('reduced-motion', initial === 'off');
  }

  @listen({
    event: 'change',
    target: ESLMediaQuery.for('@reduced-motion'),
  })
  static onReducedMotionChange(e: MediaQueryListEvent): void {
    const value = e.matches ? 'off' : 'on';
    localStorage.setItem(HPEReducedMotionInit.KEY, value);
  }
}
